import {
  Col,
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Button,
  Upload,
  Modal,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import { Label } from "reactstrap";
import {
  DeleteIcon,
  EyeIcon,
  Trash2Icon,
  TrashIcon,
  UploadIcon,
  X,
  FileText,
  CheckCircle2,
  Loader2,
} from "lucide-react";
import { extractDocumentInfoAPI } from "../../Services/EmployeeOnboarding";

const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  // "image/gif",
  // "image/webp",
  "application/pdf",
];

const normalizeSelectValue = (value) =>
  value === "" || value === null || value === undefined ? undefined : value;

const getSelectPlaceholder = (name) => {
  const normalized = String(name || "")
    .trim()
    .toLowerCase();
  if (normalized === "relationship with nominee") {
    return "Select Relationship";
  }
  return `Select ${name}...`;
};

export function Text4({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  value,
  onChange,
  noHtmlId,
  type,
  maxLength,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange && onChange(e.target.value),
                field.onChange(e.target.value)
              )}
              value={field?.value || value}
              placeholder={`Enter ${name}...`}
              disabled={disabled}
              maxLength={maxLength}
            />
          )}
        />

        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
        {/* {errors && errors[id]?.type === "pattern" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Field is Invalid
          </span>
        )} */}
      </Row>
    </Col>
  );
}

export function Text2({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
  type,
  maxLength,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange && onChange(e.target.value),
                field.onChange(e.target.value)
              )}
              value={field.value}
              placeholder={`Enter ${name}...`}
              disabled={disabled}
              maxLength={maxLength}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Text1({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
  type,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange(e.target.value),
                field.onChange(e.target.value)
              )}
              value={field.value}
              placeholder={`Enter ${name}...`}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function TextArea1({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <TextArea
              rows={4}
              id={id}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => {
                onChange && onChange(e.target.value);
                field.onChange(e.target.value);
              }}
              value={field.value}
              placeholder={`Enter ${name}...`}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select4({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
  value,
  disabled,
  onChange,
  showSearch = false,
  lg = 6,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={lg}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              style={{ width: "100%" }}
              id={id}
              placeholder={getSelectPlaceholder(name)}
              options={options}
              disabled={disabled}
              showSearch={showSearch}
              optionFilterProp={showSearch ? "label" : undefined}
              allowClear={showSearch}
              value={normalizeSelectValue(field.value ?? value)}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select2({
  id,
  name,
  control,
  className,
  defaultopt,
  options,
  errors,
  validations,
  disabled,
  onChange,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              defaultValue={defaultopt}
              style={{ width: "100%" }}
              id={id}
              allowClear
              showSearch
              placeholder={getSelectPlaceholder(name)}
              options={options}
              disabled={disabled}
              value={normalizeSelectValue(field.value)}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}
export function SelectMultiple({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
  onChange,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              id={id}
              placeholder={getSelectPlaceholder(name)}
              options={options}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
              value={normalizeSelectValue(field.value)}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select1({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              style={{ width: "100%" }}
              id={id}
              placeholder={getSelectPlaceholder(name)}
              options={options}
              value={normalizeSelectValue(field.value)}
              onChange={(val) => field.onChange(val)}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Radio2({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
  options,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Radio.Group
              {...field}
              disabled={disabled}
              style={{ width: "100%" }}
              options={options}
              optionType="button"
              buttonStyle="outline"
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Date4({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
  value,
  onChange,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          defaultValue={null}
          render={({ field }) => (
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              allowClear
              inputReadOnly={false}
              id={id}
              placeholder={`Select ${name}...`}
              value={
                field.value && dayjs(field.value).isValid()
                  ? dayjs(field.value)
                  : value && dayjs(value).isValid()
                    ? dayjs(value)
                    : null
              }
              onChange={(date) => {
                const finalValue =
                  date && dayjs(date).isValid()
                    ? dayjs(date).format("YYYY-MM-DD")
                    : null;

                field.onChange(finalValue);
                onChange?.(finalValue);
              }}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Date2({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          defaultValue=""
          render={({ field }) => (
            <DatePicker
              style={{ width: "100%" }}
              id={id}
              placeholder={`Select ${name}...`}
              value={
                field.value === "" ? null : dayjs(field.value, "YYYY-MM-DD")
              }
              onChange={(dayjs, str) => {
                field.onChange(str);
              }}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function DateRange4({
  id,
  name,
  control,
  className,
  errors,
  validations,
}) {
  const { RangePicker } = DatePicker;
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <RangePicker style={{ width: "100%" }} id={id} {...field} />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Number4({
  id,
  name,
  control,
  className,
  errors,
  validations,
  prefix,
  suffix,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <InputNumber
              style={{ width: "100%" }}
              addonAfter={suffix}
              addonBefore={prefix}
              id={id}
              {...field}
              placeholder={`Enter ${name}...`}
            />
          )}
        />
        {errors && errors[id] && (
          <span
            className="text-danger text-xs block mt-1"
            role="alert"
          >
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Checkbox4({
  id,
  name,
  control,
  className,
  onChange,
  disabled,
  defaultChecked,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative "
        style={{ height: "100%", width: "100%" }}
      >
        <Controller
          name={id}
          control={control}
          render={({ field }) => (
            <Checkbox
              checked={field.value ?? defaultChecked ?? false}
              onChange={(event) => {
                const nextValue = event.target.checked;
                field.onChange(nextValue);
                onChange && onChange(nextValue);
              }}
              style={{ marginRight: "5px", marginBottom: "10px" }}
              id={id}
            />
          )}
        />
        <Label className="fs-6 text-secondary" for={id}>
          {name}
        </Label>
      </Row>
    </Col>
  );
}

export function UploadField({
  id,
  name,
  control,
  validations,
  errors,
  className,
  disabled,
  onChange,
  value,
}) {
  const [fileUrl, setFileUrl] = useState("");
  const [fileType, setFileType] = useState(""); // "image" | "pdf" | ""

  const [isImage, setIsImage] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const [fileName, setFileName] = useState("View Document");

  // Watch the value of this field using react-hook-form's useWatch
  const watchedValue = useWatch({
    control,
    name: id,
  });

  // Update preview when watchedValue changes
  useEffect(() => {
    let urlToRevoke = null;
    // Only use fallback 'value' if the form field is undefined (not yet touched/init)
    // If it's null, it means the user specifically cleared it.
    let actualValue = watchedValue !== undefined ? watchedValue : value;

    if (!actualValue) {
      setFileUrl("");
      setIsImage(false);
      setFileName("View Document");
      return;
    }

    let file = Array.isArray(actualValue) ? actualValue[0] : actualValue;

    if (file instanceof File) {
      urlToRevoke = URL.createObjectURL(file);
      setFileUrl(urlToRevoke);
      setFileName(file.name);

      if (file.type.startsWith("image/")) {
        setFileType("image");
      } else if (file.type === "application/pdf") {
        setFileType("pdf");
      } else {
        setFileType("");
      }
    } else if (typeof file === "string") {
      setFileUrl(file);
      if (/\.(jpe?g|png|gif|webp)(?:\?.*)?$/i.test(file) || file.includes("png") || file.includes("jpg") || file.includes("jpeg") || file.includes("image")) {
        setFileType("image");
      } else if (/\.pdf(?:\?.*)?$/i.test(file) || file.includes("pdf")) {
        setFileType("pdf");
      } else {
        setFileType("pdf"); // Fallback
      }
      setFileName("View Document");
    } else if (file && typeof file === "object" && file.url) {
      setFileUrl(file.url);
      if (/\.(jpe?g|png|gif|webp)(?:\?.*)?$/i.test(file.url) || file.url.includes("png") || file.url.includes("jpg") || file.url.includes("jpeg") || file.url.includes("image")) {
        setFileType("image");
      } else if (/\.pdf(?:\?.*)?$/i.test(file.url) || file.url.includes("pdf")) {
        setFileType("pdf");
      } else {
        setFileType("pdf"); // Fallback
      }
      setFileName("View Document");
    } else {
      setFileUrl("");
      setFileType("");
      setFileName("View Document");
    }

    return () => {
      if (urlToRevoke) URL.revokeObjectURL(urlToRevoke);
    };
  }, [watchedValue]);

  return (
    <Col
      className={`px-3 py-2 ${className || ""}`}
      lg={className?.includes("w-full") ? 24 : 8}
      sm={className?.includes("w-full") ? 24 : 12}
      xs={24}
    >
      <div className="flex items-center justify-between border rounded-xl px-4 py-3 bg-white shadow-sm hover:shadow-md transition">
        {/* LEFT SIDE */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-md">
            📄
          </div>

          <div>
            <p className="text-sm font-medium text-gray-800 m-0">
              {name}
              {validations?.required && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </p>
            {fileUrl ? null : (
              <p className="text-xs text-gray-400 m-0 mt-0.5">PDF, JPG or PNG</p>
            )}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <div className="flex items-center gap-3">
              {/* ✅ Uploaded State */}
              {fileUrl && (
                <>
                  <Button
                    type="link"
                    size="small"
                    icon={<EyeIcon size={16} />}
                    className="p-0 border-none hover:bg-gray-100 rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPreviewOpen(true);
                    }}
                  />

                  {!disabled && (
                    <span
                      className="text-red-500 cursor-pointer p-1 rounded hover:bg-red-50"
                      onClick={() => {
                        field.onChange(null);
                        onChange?.(null);
                      }}
                    >
                      <Trash2Icon size={18} />
                    </span>
                  )}
                </>
              )}

              {/* ✅ Upload Button */}
              {!fileUrl && (
                <Upload
                  accept="image/*,.pdf"
                  beforeUpload={(file) => {
                    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
                      Modal.error({
                        title: "Invalid File Type",
                        content:
                          "Only Images (JPG, JPEG, PNG) or PDF files are allowed.",
                      });
                      return Upload.LIST_IGNORE; // ❌ reject file
                    }
                    field.onChange(file);
                    onChange?.(file);
                    return false;
                  }}
                  maxCount={1}
                  disabled={disabled}
                  fileList={[]}
                  onRemove={() => {
                    field.onChange(null);
                    onChange?.(null);
                  }}
                  showUploadList={false}
                >
                  <button type="button" className="hover:opacity-90">
                    <UploadIcon size={25} className="mt-1" color="#009bde" />
                  </button>
                </Upload>
              )}
            </div>
          )}
        />
        <Modal
          open={previewOpen}
          footer={null}
          onCancel={() => setPreviewOpen(false)}
          centered
          width="80%"
          bodyStyle={{ height: "80vh", padding: 0 }}
        >
          {fileType === "image" ? (
            <img
              alt="Preview"
              src={fileUrl}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                display: "block",
                margin: "0 auto",
              }}
            />
          ) : fileType === "pdf" ? (
            <iframe
              src={fileUrl}
              title="PDF Preview"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          ) : null}
        </Modal>
      </div>

      {/* ERROR */}
      {errors?.[id] && (
        <span className="text-danger text-xs block mt-1">
          {errors[id]?.message || `${name} is required`}
        </span>
      )}
    </Col>
  );
}

const hasNonEmptyExtractedValue = (extracted) => {
  if (!extracted || typeof extracted !== "object") return false;
  return Object.values(extracted).some((val) => {
    if (Array.isArray(val)) return val.length > 0;
    if (val === null || val === undefined) return false;
    return String(val).trim() !== "";
  });
};

const formatFieldLabel = (key) =>
  key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

// Upload field that additionally runs the uploaded document through the
// OCR extraction API and surfaces uploaded/extracted/failed state inline.
export function VerifiedUploadField({
  id,
  name,
  control,
  validations,
  errors,
  className,
  disabled,
  onChange,
  value,
  onStatusChange,
  // When set, OCR extraction runs on upload and the detected document_type
  // must match this value. When omitted, the file is uploaded with no OCR call.
  expectedDocumentType,
}) {
  const [fileUrl, setFileUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [dataModalOpen, setDataModalOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  // empty | existing | checking | extracted | no-data | failed | mismatch
  const [status, setStatus] = useState("empty");
  const [attempts, setAttempts] = useState(0);
  const [extractedPages, setExtractedPages] = useState([]);

  const watchedValue = useWatch({ control, name: id });

  useEffect(() => {
    onStatusChange?.(id, status);
  }, [id, status, onStatusChange]);

  // Keep preview in sync. Only seeds "existing" for previously-uploaded
  // (string/url) values — freshly selected Files drive status via runExtraction.
  useEffect(() => {
    let urlToRevoke = null;
    let actualValue = watchedValue !== undefined ? watchedValue : value;

    if (!actualValue) {
      setFileUrl("");
      setFileName("");
      setStatus("empty");
      return;
    }

    let file = Array.isArray(actualValue) ? actualValue[0] : actualValue;

    if (file instanceof File) {
      urlToRevoke = URL.createObjectURL(file);
      setFileUrl(urlToRevoke);
      setFileName(file.name);
      setFileType(file.type === "application/pdf" ? "pdf" : "image");
    } else if (typeof file === "string") {
      setFileUrl(file);
      setFileName("View Document");
      setFileType(
        /\.pdf(?:\?.*)?$/i.test(file) || file.includes("pdf") ? "pdf" : "image",
      );
      setStatus((prev) => (prev === "empty" ? "existing" : prev));
    } else if (file && typeof file === "object" && file.url) {
      setFileUrl(file.url);
      setFileName("View Document");
      setFileType(
        /\.pdf(?:\?.*)?$/i.test(file.url) || file.url.includes("pdf")
          ? "pdf"
          : "image",
      );
      setStatus((prev) => (prev === "empty" ? "existing" : prev));
    } else {
      setFileUrl("");
      setFileName("");
      setStatus("empty");
    }

    return () => {
      if (urlToRevoke) URL.revokeObjectURL(urlToRevoke);
    };
  }, [watchedValue]);

  const runExtraction = async (file) => {
    setStatus("checking");
    try {
      const { data } = await extractDocumentInfoAPI(file);
      const pages = data?.data?.pages || [];
      const isClear = Boolean(data?.success) && data?.data?.is_clear !== false;

      if (!isClear) {
        setExtractedPages([]);
        setStatus("failed");
        return;
      }

      if (expectedDocumentType) {
        const detectedTypes = pages
          .map((page) => page?.document_type)
          .filter(Boolean);
        const isMismatched =
          detectedTypes.length > 0 &&
          !detectedTypes.includes(expectedDocumentType);

        if (isMismatched) {
          setExtractedPages([]);
          setStatus("mismatch");
          return;
        }
      }

      const hasData = pages.some((page) =>
        hasNonEmptyExtractedValue(page?.extracted),
      );

      if (hasData) {
        setExtractedPages(pages);
        setStatus("extracted");
      } else {
        setExtractedPages([]);
        setStatus("no-data");
      }
    } catch (err) {
      console.error("OCR extraction error:", err);
      setExtractedPages([]);
      setStatus("failed");
    }
  };

  const hasFile = Boolean(fileUrl);
  const isChecking = status === "checking";
  const isExtracted = status === "extracted";
  const isFailed = status === "failed";
  const isMismatch = status === "mismatch";

  return (
    <Col
      className={`px-3 py-2 ${className || ""}`}
      lg={className?.includes("w-full") ? 24 : 8}
      sm={className?.includes("w-full") ? 24 : 12}
      xs={24}
    >
      <Controller
        name={id}
        control={control}
        rules={validations}
        render={({ field }) => {
          const triggerUpload = (file) => {
            if (!ALLOWED_FILE_TYPES.includes(file.type)) {
              Modal.error({
                title: "Invalid File Type",
                content:
                  "Only Images (JPG, JPEG, PNG) or PDF files are allowed.",
              });
              return Upload.LIST_IGNORE;
            }
            field.onChange(file);
            onChange?.(file);
            setAttempts((a) => a + 1);
            if (expectedDocumentType) {
              runExtraction(file);
            } else {
              setExtractedPages([]);
              setStatus("no-data");
            }
            return false;
          };

          const clearFile = () => {
            field.onChange(null);
            onChange?.(null);
            setExtractedPages([]);
            setStatus("empty");
          };

          return (
            <div
              className={`h-full flex flex-col rounded-xl px-4 py-3 border shadow-sm hover:shadow-md transition ${
                isFailed || isMismatch
                  ? "border-red-300 bg-red-50"
                  : "border-gray-200 bg-white"
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center text-blue-500 mt-0.5 shrink-0">
                    <FileText size={20} />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-800 m-0">
                      {name}
                      {validations?.required && (
                        <span className="text-red-500 ml-1">*</span>
                      )}
                    </p>
                    <p className="text-xs text-gray-400 m-0 mt-0.5">
                      {fileName || "PDF, JPG, JPEG or PNG"}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  {hasFile ? (
                    <>
                      <Button
                        type="link"
                        size="small"
                        icon={<EyeIcon size={16} />}
                        className="p-0 border-none hover:bg-gray-100 rounded"
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewOpen(true);
                        }}
                      />
                      {!disabled && (
                        <span
                          className="text-red-500 cursor-pointer p-1 rounded hover:bg-red-50"
                          onClick={clearFile}
                        >
                          <Trash2Icon size={18} />
                        </span>
                      )}
                    </>
                  ) : (
                    <Upload
                      accept="image/*,.pdf"
                      beforeUpload={triggerUpload}
                      maxCount={1}
                      disabled={disabled}
                      fileList={[]}
                      showUploadList={false}
                    >
                      <button
                        type="button"
                        disabled={disabled}
                        className="w-8 h-8 flex items-center justify-center border rounded-full hover:opacity-80"
                      >
                        <UploadIcon size={16} color="#009bde" />
                      </button>
                    </Upload>
                  )}
                </div>
              </div>

              {hasFile && (
                <div className="mt-2 space-y-1">
                  <div className="flex items-center gap-1.5 text-xs text-green-600">
                    <CheckCircle2 size={14} /> Document uploaded
                  </div>

                  {isChecking && (
                    <div className="flex items-center gap-1.5 text-xs text-blue-500">
                      <Loader2 size={14} className="animate-spin" />{" "}
                      Extracting information...
                    </div>
                  )}

                  {isExtracted && (
                    <>
                      <div className="flex items-center gap-1.5 text-xs text-green-600">
                        <CheckCircle2 size={14} /> Information extracted
                      </div>
                      <button
                        type="button"
                        className="text-xs text-blue-600 underline hover:text-blue-700 bg-transparent border-none p-0 cursor-pointer"
                        onClick={() => setDataModalOpen(true)}
                      >
                        View Extracted Data
                      </button>
                    </>
                  )}

                  {isFailed && (
                    <>
                      <p className="text-xs text-red-600 m-0 mt-1">
                        We couldn't extract information from this document.
                        Please upload a clearer copy.
                      </p>
                      <Upload
                        accept="image/*,.pdf"
                        beforeUpload={triggerUpload}
                        maxCount={1}
                        disabled={disabled}
                        fileList={[]}
                        showUploadList={false}
                      >
                        <button
                          type="button"
                          disabled={disabled}
                          className="text-xs text-red-600 font-medium underline bg-transparent border-none p-0 cursor-pointer"
                        >
                          Re-upload
                        </button>
                      </Upload>
                    </>
                  )}

                  {isMismatch && (
                    <>
                      <p className="text-xs text-red-600 m-0 mt-1">
                        This document doesn't match "{name}". Please upload
                        the correct document.
                      </p>
                      <Upload
                        accept="image/*,.pdf"
                        beforeUpload={triggerUpload}
                        maxCount={1}
                        disabled={disabled}
                        fileList={[]}
                        showUploadList={false}
                      >
                        <button
                          type="button"
                          disabled={disabled}
                          className="text-xs text-red-600 font-medium underline bg-transparent border-none p-0 cursor-pointer"
                        >
                          Re-upload
                        </button>
                      </Upload>
                    </>
                  )}

                  {attempts > 0 && (
                    <p className="text-[11px] text-gray-400 m-0 mt-1">
                      Attempts: {attempts}
                    </p>
                  )}
                </div>
              )}

              {errors?.[id] && (
                <span className="text-danger text-xs block mt-1">
                  {errors[id]?.message || `${name} is required`}
                </span>
              )}
            </div>
          );
        }}
      />

      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        centered
        width="80%"
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {fileType === "image" ? (
          <img
            alt="Preview"
            src={fileUrl}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              display: "block",
              margin: "0 auto",
            }}
          />
        ) : fileType === "pdf" ? (
          <iframe
            src={fileUrl}
            title="PDF Preview"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        ) : null}
      </Modal>

      <Modal
        title={`${name} — Extracted Data`}
        open={dataModalOpen}
        footer={null}
        onCancel={() => setDataModalOpen(false)}
        centered
      >
        {extractedPages.map((page, idx) => (
          <div key={idx} className="mb-3">
            {extractedPages.length > 1 && (
              <p className="text-xs font-semibold text-gray-500 mb-1">
                Page {page?.page_number || idx + 1}
              </p>
            )}
            {Object.entries(page?.extracted || {}).map(([key, val]) => {
              if (key === "subjects") {
                if (!Array.isArray(val) || val.length === 0) return null;
                return (
                  <div key={key} className="mb-2">
                    <p className="text-xs font-medium text-gray-600 mb-1">
                      Subjects
                    </p>
                    <div className="overflow-x-auto">
                      <table className="text-xs w-full border-collapse">
                        <thead>
                          <tr>
                            <th className="text-left border-b py-1 pr-2">
                              Subject
                            </th>
                            <th className="text-left border-b py-1 pr-2">
                              Full Marks
                            </th>
                            <th className="text-left border-b py-1 pr-2">
                              Pass Marks
                            </th>
                            <th className="text-left border-b py-1">
                              Marks Obtained
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {val.map((subject, subjectIdx) => (
                            <tr key={subjectIdx}>
                              <td className="py-1 pr-2 border-b">
                                {subject.subject}
                              </td>
                              <td className="py-1 pr-2 border-b">
                                {subject.full_marks}
                              </td>
                              <td className="py-1 pr-2 border-b">
                                {subject.pass_marks}
                              </td>
                              <td className="py-1 border-b">
                                {subject.marks_obtained}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              }

              if (val === null || val === undefined || String(val).trim() === "")
                return null;

              return (
                <div
                  key={key}
                  className="flex justify-between text-xs py-1 border-b border-gray-100"
                >
                  <span className="text-gray-500">{formatFieldLabel(key)}</span>
                  <span className="text-gray-800 font-medium text-right ml-2">
                    {String(val)}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </Modal>
    </Col>
  );
}
